export enum ValidationType {
    VerificarAfiliado = 1,

}
